import * as legacyRequesters from './legacyHarvestRequester/legacyHarvestRequester';
import * as olRequesters from './olHarvestRequester/olHarvestRequester';


export type RequestHarvestSeasonParams = {
  fieldUUID: string;
  userId: number;
  useOl: boolean;
}
/*
  To ensure an easy transition, the harvest call to OL will be
  behind a feature flag, we might increase dial up pecentage
  every day until we reach 100%, after that, we can remove
  the legacy call entirely.
*/
export function requestHarvestSeasons({fieldUUID, userId, useOl}: RequestHarvestSeasonParams) {
  if (useOl) {
    return olRequesters.requestHarvestSeasons(fieldUUID);
  }

  return legacyRequesters.requestHarvestSeasons(fieldUUID, userId);
}
